module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.pageName.replace('en_', '') == 'post') ? _c('header', [(_vm.projectName != 'all') ? _c('pageTemplateProjectHeader') : _vm._e(), _c('p', {
    staticClass: "pageTitle",
    class: _vm.projectName
  }, [_vm._v(_vm._s(_vm.renderText('活動報告', 'ACTIVITY')))])]) : _vm._e(), _c('div', [(_vm.pageName.replace('en_', '') == 'post') ? _c('p', {
    staticClass: "meta"
  }, [_c('span', {
    staticClass: "category",
    class: _vm.category(_vm.post).slug
  }, [_vm._v(_vm._s(_vm.renderText(_vm.category(_vm.post).label.ja, _vm.category(_vm.post).label.en)))]), _c('span', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.renderText(_vm.post.acf.displayDate, _vm.post.acf.displayDateEn)))])]) : _vm._e(), (!_vm.isEnglish && _vm.styledTitleJa) ? _c('h2', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.styledTitleJa)
    }
  }) : (_vm.isEnglish && _vm.styledTitleEn) ? _c('h2', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.styledTitleEn)
    }
  }) : _c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.renderText(_vm.post.title.rendered, _vm.post.acf.titleEn)))]), _c('htmlRenderer', {
    attrs: {
      "content": _vm.renderText(_vm.post.acf.textJa, _vm.post.acf.textEn)
    }
  })]), _c('footer', {
    staticClass: "singleFooter"
  }, [_c('p', {
    staticClass: "back",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("← " + _vm._s(_vm.renderText('戻る', 'BACK')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ee073486!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/single/singleTemplate.vue
// module id = 111
// module chunks = 1